<template>
  <div class="Index">
    <div class="l-container">

      <h1 class="m-label m-label-custom" @click="switchC('column')" v-bind:class="{ 'slideActive': column }" v-ripple>項目</h1>
      <template v-if="column">
        <div style="display: flex; flex-wrap: wrap">
          <btn class="m-btn--column" @click.native="reset()">RESET</btn>
          <btn class="m-btn--column" @click.native="all()">ALL</btn>
          <div v-for="(list, index) in jsonChannels" :key="index.id">
            <btn class="m-btn--column" @click.native="switchV(index)" v-bind:class="{ 'active': columns.indexOf(index) >= 0 }">{{list}}</btn>
          </div>

          <div v-for="(list, index) in officeNames" :key="index.id">
            <btn class="m-btn--column" @click.native="switchS(index)" v-bind:class="{ 'active': sides.indexOf(index) >= 0 }">{{list}}</btn>
          </div>

          <div v-for="(list, index) in prefNames" :key="index.id">
            <btn class="m-btn--column" @click.native="switchSP(index)" v-bind:class="{ 'active': sidePrefs.indexOf(index) >= 0 }">{{list}}</btn>
          </div>

        </div>
      </template>

      <div class="wrapper">

        <div class="list-box">
          <table-c>
            <tr-c slot="tr-th">
              <th-c style="background: #f6fdff">期間検索</th-c>
              <th-c style="background: #f6fdff">登録日</th-c>
              <td-c><input v-model="search.registration_date[0]" type="text" @keyup="searchTable()" placeholder="登録日"></td-c>
              <td-c><input v-model="search.registration_date[1]" type="text" @keyup="searchTable()" placeholder="〜登録日"></td-c>
            </tr-c>
          </table-c>
        </div>

        <div class="list-box2">

          <table-c>

            <tr-c slot="tr-th">
              <th-c class="sticky-1"></th-c>
              <td-c v-if="columns.indexOf(index) >= 0" class="sticky-1" v-for="(list, index) in jsonChannels" :key="index.id">{{list}}</td-c>
              <th-c class="sticky-1">合計</th-c>
            </tr-c>

            <tr-c class="office" slot="tr-th" v-for="(list, index) in sums" :key="index.id">
              <template v-if="sides.indexOf(index) >= 0">
                <th-c>{{officeNames[index]}}</th-c>
                <td-c v-if="columns.indexOf(index) >= 0" v-for="(list, index) in sums[index]" :key="index.id">{{list}}</td-c>
                <td-c>{{list[list.length - 1]}}</td-c>
              </template>
            </tr-c>

            <tr-c slot="tr-th" v-for="(list, index) in prefs" :key="index.id">
              <template v-if="sidePrefs.indexOf(index) >= 0">
                <th-c>{{prefNames[index]}}</th-c>
                <td-c v-if="columns.indexOf(index) >= 0" v-for="(list, index) in prefs[index]" :key="index.id">{{list}}</td-c>
                <td-c>{{list[list.length - 1]}}</td-c>
              </template>
            </tr-c>

          </table-c>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { getAPIURL } from '@/store/getters.js'
// import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/aggregate_tutor_channels'

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  // offset: config.LIMIT,
  // max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  pageName: 'aggregate_tutor_channel',
  pageNames: 'aggregate_tutor_channels'
}

export default {
  props: {
    dtp: Object
  },

  data () {
    return {
      column: false,
      asc: '',
      desc: '',
      sortState: '',
      columns: [],
      sides: [],
      sidePrefs: [],
      search: {
        registration_date: []
      }
    }
  },

  computed: {
    user () {
      return this.$store.getters.user
    },

    aggregate_tutor_channel () {
      return this.$store.getters.aggregate_tutor_channel
    },

    channels () {
      return this.$store.getters.channels
    },

    filteredChannels () {
      const self = this
      return self.channels.filter((channel) => {
        return channel.state === 1
      })
    },

    offices () {
      return this.$store.getters.offices
    },

    filteredOffices () {
      const self = this
      return self.offices.filter((office) => {
        return office.id === self.user.office_id
      })
    },

    // 媒体名を配列に
    jsonChannels () {
      if (this.aggregate_tutor_channel.channel) {
        const keys = Object.keys(this.aggregate_tutor_channel.channel)
        const jsonChannels = keys.map((key) => {
          return this.aggregate_tutor_channel.channel[key]
        })
        return jsonChannels
      }
    },

    // 営業所毎のjsonを配列に
    sums () {
      if (this.aggregate_tutor_channel.channel) {
        const keys = Object.keys(this.aggregate_tutor_channel.sum)
        const sums = keys.map((key) => {
          const Bkeys = Object.keys(this.aggregate_tutor_channel.sum[key])
          const Bsums = Bkeys.map((Bkey) => {
            return this.aggregate_tutor_channel.sum[key][Bkey]
          })
          return Bsums
        })
        return sums
      }
    },

    // 都道府県毎のjsonを配列に
    prefs () {
      if (this.aggregate_tutor_channel.channel) {
        const keys = Object.keys(this.aggregate_tutor_channel.pref)
        const prefs = keys.map((key) => {
          const Bkeys = Object.keys(this.aggregate_tutor_channel.pref[key])
          const Bprefs = Bkeys.map((Bkey) => {
            return this.aggregate_tutor_channel.pref[key][Bkey]
          })
          return Bprefs
        })
        return prefs
      }
    },

    // 営業所名を配列に
    officeNames () {
      if (this.aggregate_tutor_channel.channel) {
        const keys = Object.keys(this.aggregate_tutor_channel.sum)
        return keys
      }
    },

    // 都道府県名を配列に
    prefNames () {
      if (this.aggregate_tutor_channel.channel) {
        const keys = Object.keys(this.aggregate_tutor_channel.pref)
        return keys
      }
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getUser()
      vm.getAggregateTutorChannel()
      vm.getChannels()
    })
  },

  methods: {
    switchC (col) {
      this[col] = !this[col]
    },

    switchV (index) {
      if (this.columns.indexOf(index) >= 0) {
        this.columns = this.columns.filter(function (column) {
          return column !== index
        })
      } else {
        this.columns.push(index)
      }
    },

    switchS (index) {
      console.log(index)
      if (this.sides.indexOf(index) >= 0) {
        this.sides = this.sides.filter(function (side) {
          return side !== index
        })
      } else {
        this.sides.push(index)
      }
    },

    switchSP (index) {
      console.log(index)
      if (this.sidePrefs.indexOf(index) >= 0) {
        this.sidePrefs = this.sidePrefs.filter(function (sideP) {
          return sideP !== index
        })
      } else {
        this.sidePrefs.push(index)
      }
    },

    reset () {
      this.columns = []
    },

    all () {
      const self = this
      for (let i = 0; i < self.jsonChannels.length; i++) {
        self.columns.push(i)
      }
    },

    searchTable (e) {
      // let that = this
      let search = this.search
      var store = this.$store
      var params = {}
      function searchTable () {
        // aggregate
        var paramsList = [
          'registration_date'
        ]
        paramsList.forEach((e) => {
          if (search[e][1]) {
            params[e] = [search[e][0], search[e][1]]
          } else {
            params[e] = [search[e][0]]
          }
        })
        axios.get(obj.url, {params: params, withCredentials: true})
        .then((response) => {
        // success callback
          console.log(response)
          store.state.item.aggregate_tutor_channel = response.data
        }, (response) => {
        // error callback
        })
      }

      if (obj.TIMER) {
        clearTimeout(obj.TIMER)
        obj.TIMER = setTimeout(searchTable, obj.wait)
        return
      }
      obj.TIMER = setTimeout(searchTable, obj.wait)
    },

    getUser () {
      this.$store.dispatch('getUser')
    },

    getAggregateTutorChannel () {
      this.$store.dispatch('getAggregateTutorChannel')
    },

    getChannels () {
      this.$store.dispatch('getChannels')
    }
  },

  mounted () {
    const self = this
    self.columns = self.filteredChannels.map((channel) => {
      const columns = channel.id - 1
      return columns
    })
    if (self.user.office_id === 0) {
      this.sides = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
      this.sidePrefs = []
    } else if (self.user.office_id === 1) {
      this.sides = [0]
      this.sidePrefs = [3, 4, 5, 6]
    } else if (self.user.office_id === 2) {
      this.sides = [1]
      this.sidePrefs = [0]
    } else if (self.user.office_id === 3) {
      this.sides = [2]
      this.sidePrefs = [17, 18, 23, 24, 25]
    } else if (self.user.office_id === 4) {
      this.sides = [3]
      this.sidePrefs = [39, 40, 41, 42, 43, 44, 45]
    } else if (self.user.office_id === 9) {
      this.sides = [8]
      this.sidePrefs = [7, 9, 11, 12, 13, 14]
    }
  }
}
</script>

<style lang="scss">
.Index {
}
</style>
<style lang="scss" scoped>
.sticky-1 {
  position: sticky;
  top: 0;
  background: #fff;
  &:before {
    content: '';
    position: absolute;
    display: block;
    background: #ccc;
    height: 1px;
    width: 100%;
    left: 0;
    top: -1px;
  }
  &:after {
    content: '';
    position: absolute;
    display: block;
    background: #ccc;
    height: 1px;
    width: 100%;
    left: 0;
    bottom: -1px;
  }
}

.list-box2 {
  height: calc(100vh - 180px);
  overflow: auto;
}

.m-label-custom {
  z-index: 1;
  cursor: pointer;
  margin-bottom: 1px;
}

.slideActive {
  background: #455A64;
  color: #fff;
}

.active {
  background: #455A64;
  border: solid 1px #455A64;
  color: #fff;
}

.wrapper {
  .list-box {
    margin-bottom: 15px;
  }
}

.table {
  margin-top: 0 !important;
}

.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}

.th {
  cursor: pointer;
}

input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}

#bar-chart {

}

.office {
  background: #dffbef;
}
</style>



// WEBPACK FOOTER //
// AggregatesTutorChannels.vue?f5dd47e6